import React, {Component} from 'react'
import {izBlank} from "../constants";

export default class CustomLi extends Component {

    render() {

        let {title, detail, hide, addDotsToTitle} = this.props;

        if (hide) return ""
        if (izBlank(detail)) return ""
        if (addDotsToTitle === true) title = title + ":";

        return (
            <li>
                <strong>{title} </strong>
                <span>{detail}</span>
            </li>
        )
    }
}